import PagePlaceholder from '@/components/PagePlaceholder';

export default function IntegrationsPage() {
  return (
    <PagePlaceholder
      title="Integrations"
      subtitle="Connect what you already have. Unify systems, data and workflows across your organization."
    />
  );
}